/**
 * 计量处罚 - 汇总统计卡片
 */
import React from 'react';
import { hooks } from '@tencent/ptp-fe-common';
import { scientific } from '@/utils/formater';
import { getIllegalEventSummary } from '../api';

const { useFetch } = hooks;

interface SummaryData {
  /** 待处理数量（状态1+2） */
  pending_count?: number;
  /** 即将升级数量（状态1且亮灯时间超过5天） */
  escalate_count?: number;
  /** 已处理数量（状态3） */
  processed_count?: number;
  /** 处理率（0~1） */
  process_rate?: number;
}

interface SummaryStatsProps {
  /** 可选：外部传入数据（不传则组件内部自行请求） */
  data?: SummaryData;
  loading?: boolean;
}

const SummaryStats: React.FC<SummaryStatsProps> = ({ data: outerData, loading: outerLoading }) => {
  /** 组件内部请求汇总数据，避免外部重复调用 */
  const { data: innerData, fetching: innerLoading } = useFetch(
    getIllegalEventSummary,
    {},
    {},
    true,
    undefined,
    (res: any) => res?.data || {},
  );

  const data: SummaryData = outerData ?? innerData ?? {};
  const loading = outerLoading ?? innerLoading;

  const {
    pending_count = 0,
    escalate_count = 0,
    processed_count = 0,
    process_rate = 0,
  } = data || {};

  const handleRate = process_rate > 0
    ? `${scientific(process_rate * 100, 2)}%`
    : '-';

  const items = [
    {
      key: 'pending',
      label: '待处理',
      value: scientific(pending_count, 0),
      bgClass: 'tw-bg-red-50',
    },
    {
      key: 'escalate',
      label: '即将升级',
      value: scientific(escalate_count, 0),
      bgClass: 'tw-bg-amber-50',
    },
    {
      key: 'processed',
      label: '已处理',
      value: scientific(processed_count, 0),
      bgClass: 'tw-bg-green-50',
      extra: `处理率：${handleRate}`,
    },
  ];

  return (
    <div className={`tw-flex tw-gap-[16px] ${loading ? ' tw-opacity-50 tw-pointer-events-none' : ''}`}>
      {items.map((item) => (
        <div
          key={item.key}
          className={`tw-flex-1 tw-rounded tw-px-[20px] tw-py-[16px] ${item.bgClass}`}
        >
          <div className="tw-mb-[12px]">
            <span className="tw-text-gray-600">{item.label}</span>
          </div>
          <div className="tw-flex tw-items-center tw-gap-[8px]">
            <div className="tw-font-semibold tw-text-gray-800">
              {item.value}
            </div>
            {item.extra ? (
              <span className="tw-text-gray-500">{item.extra}</span>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryStats;
